import { render, staticRenderFns } from "./BeamForm.vue?vue&type=template&id=abd73a20&scoped=true"
import script from "./BeamForm.vue?vue&type=script&lang=js"
export * from "./BeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd73a20",
  null
  
)

export default component.exports